import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

function HostSideBar() {

   const [firstLetter, setFirstLetter] = useState("R"); // fallback

  useEffect(() => {
    const userData = localStorage.getItem("user"); // 🔹 key must match how you store it
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        
         if (parsed.first_name && parsed.first_name.trim() !== "") {
          setFirstLetter(parsed.first_name.charAt(0).toUpperCase());
        } else if (parsed.email) {
          setFirstLetter(parsed.email.charAt(0).toUpperCase());
        }

      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);
  return (
    <>
    <div className="col-lg-3 col-sm-5 mb_view_hide">
      <div className="user_allls profiles pt-0 pb-0">
            
              <div className="prfo_listst ac_settingss">
                <h4>Account Settings</h4>
                <ul>
                  <li>
                    <NavLink to={'/dashboard'} className={({ isActive }) => (isActive ? "action" : "")}>
                      <span className="titl"><img src="/images/ac_setting_ic1.png" alt="" /></span> Dashboard
                     </NavLink>
                  </li>

                  <li>
                    <NavLink to={'account-setting'}  end className={({ isActive }) => (isActive ? "action" : "")}>
                      <span className="titl"><img src="/images/ac_setting_ic2.png" alt="" /></span> Account
                    </NavLink>
                  </li>
				  
				  {/* <li>
                    <NavLink to={'account-tax'} className={({ isActive }) => (isActive ? "action" : "")}>
                     <span className="titl"><img src="/images/ac_setting_ic4.png" alt="" /></span> Taxes
                     </NavLink>           
                  </li> */}

                  {/*<li>
                    <NavLink to={''}  end className={({ isActive }) => (isActive ? "action" : "")}>
                      <span className="titl"><img src="/images/ac_setting_ic3.png" alt="" /></span> Security
                    </NavLink>
                  </li>*/}
				  
				  

				  <li>
                    <NavLink to={'/account-notification'} className={({ isActive }) => (isActive ? "action" : "")}>
                     <span className="titl"><img src="/images/ac_setting_ic5.png" alt="" /></span> Notification
                     </NavLink>
           
                  </li>
				  
                  <li>
                    <NavLink to={'/payment'} className={({ isActive }) => (isActive ? "action" : "")}>
                      <span className="titl"><img src="/images/ac_setting_ic6.png" alt="" /></span> Payments
                     </NavLink>
                  </li>
                  
                  <li>
                    <NavLink to={'account-currency'} className={({ isActive }) => (isActive ? "action" : "")}>
                     <span className="titl"><img src="/images/ac_setting_ic7.png" alt="" /></span> Currency
                     </NavLink>
           
                  </li>
                  
                  
                </ul>
              </div>
            </div>
      </div>
    </>
  );
}

export default HostSideBar;
